<template>
    <div class="oBox ">
        <form class="form-horizontal">
            <div class="form-group">
                <label  class="col-sm-2 control-label">宿舍房号 </label>
                <div class="col-sm-9">
                    <input type="text" class="form-control"  placeholder="宿舍房号" v-model="dorm " disabled> 
                </div>
            </div>
            <!-- <div class="form-group" v-if="recState==''">
                <label  class="col-sm-2 control-label">是否住宿 <i>*</i></label>
                <div class="col-sm-9">
                    <label class="radio-lable">
                        <input type="radio" name="optionsRadios" id="optionsRadios1" value="1" v-model="isDorm">住宿
                    </label>
                    <label  class="radio-lable">
                        <input type="radio" name="optionsRadios" id="optionsRadios1" value="2" v-model="isDorm">走读
                    </label>
                </div>
            </div> -->
            <div class="form-group" v-show="house" >
                <label  class="col-sm-2 control-label">生活用品 <i>*</i></label>
                <div class="col-sm-9">
                   <label  class="radio-lable">
                        <input type="radio" name="optionsRadios1" id="optionsRadios1" value="2" @click="changes" v-model="isBuy">购买
                    </label>
                    <label class="radio-lable">
                        <input type="radio" name="optionsRadios1" id="optionsRadios1" value="1"  @click="changess" v-model="isBuy">暂不购买
                    </label>
                   
                    <span class="exit" @click="_updateRoom()" v-if="exitshow">{{type[goods_state]}}</span>
                </div>
            </div>
            <div class="form-group" v-if="recState==2">
                <label  class="col-sm-2 control-label">宿舍选择<i>*</i></label>
                <div  class="col-sm-9">
                  <div class="sushe">请到校后在申请宿舍</div>
                    <!-- <div  class="peroom" >
                      <span  @click="peroom(item)" 
                          :class="{active : active == item.capacity}" 
                          v-for="(item,index) in room" 
                          :key="index" 
                        >
                        {{item.capacity+'人间'}} 
                       </span>
                    </div> -->
                </div>
            </div>
          <div class="form-group"  v-if="recState==2">
                <label  class="col-sm-2 control-label"></label>
                <div  class="col-sm-9">
                    <div  class="dormchoose" >
                      <span  @click="peDorm(item)"  
                          v-for="(item,index) in Dorm" 
                          :key="index" 
                            :class="{actives : actives == item.ssmc}" 
                        >
                          {{item.jzw_name}} #{{item.sslc}}-{{item.ssmc}}
                       </span>
                    </div>
                </div>
            </div>
             <div class="form-group" v-if="recState==2" v-show="show">
                <label  class="col-sm-2 control-label"></label>
                <div  class="col-sm-9">
                <span class="roombed">剩余床位</span>
                    <div  class="DormBedchoose" >
                      <span  @click="peDormBed(item)"  
                          v-for="(item,index) in DormBed" 
                          :key="index" 
                          :class="{activeBed : activeBed == item.id}" 
                          v-if=" item.sfzjh==''"
                        >
                          {{item.bed_no +'号床'}}
                       </span>
                    </div>
                </div>
            </div>

            <div v-if='isBuy==2' v-show="house" class='isbuyshow'>
               <ul>
                 <li class='lid' v-for='(item,index) in goods_list' :key='index'>
                     <span>{{item.goods_name}}</span>
                     <span class='num'>总计：{{item.goods_price}}</span>
                 </li>
               </ul>
            </div>
        </form>

         <div class="btn-box"  >
           <button type="button" class="btn btn-success btn-lg"  v-if="recState ==2"  @click="_dormBedApply">申请</button>
           <button type="button" class="btn btn-primary btn-lg" v-if="recState == 1" disabled>待审核</button>
           <button type="button" class="btn btn-info btn-lg" v-if="recState == 5" disabled>审核通过</button>
           <button type="button" class="btn btn-success btn-lg" v-if="recState == 0" disabled>拒绝</button>
          </div>
        <!-- 提示框   -->
        <tip :tip="tip" v-show="tipShow"></tip>
        <page-load v-if="flag"></page-load>
   
        
    </div>
</template>
<script>
import {
  getRoomInfo,
  getRoomGoogs,
  updateRoom,
  chooseCapacity,
  chooseDorm,
  chooseDormBed,
  dormBedApply,
  getMyDorm
} from "@/api/login.js";
import { loginUrl } from "../api/config";
import pageLoad from "../pageload/pageload";
let Base64 = require("js-base64").Base64;

export default {
  components: { pageLoad },
  data() {
    return {
      type: { 0: "提交", 1: "审核中", 2: "已购买" },
      goods_state: "",
      goods_list: [],
      loginUrl: loginUrl,
      dorm: "", //宿舍信息
      isDorm: 0, //是否住宿
      isBuy: 2, //生活用品
      tipShow: false, //tip提示
      show: false,
      exitshow: true,
      house: false,
      tip: "", //tip提示信息
      recState: 2, //返回节点
      flag: true,
      dorm_id: "",
      bed_id: "",
      room: [],
      Dorm: [],
      DormBed: [],
      buy_list: [],
      active: "",
      actives: "",
      activeBed: ""
    };
  },
  created() {},
  mounted() {
    this._getMyDorm();
    this._getRoomGoogs();
    this._getRoomInfo();
  },
  methods: {
    //我的记录
    _getMyDorm() {
      let module = {
        sfzjh: Base64.encode(
          JSON.parse(sessionStorage.getItem("stuInfo")).sfzjh
        )
      };
      getMyDorm(module)
        .then(res => {
          this.flag = false;
          if (res.status) {
            this.is_dorm = res.is_dorm;
            if (res.data.length != 0) {
              this.recState = res.data.apply_state;
              this.dorm =
                res.data.jzw_name +
                res.data.dorm_name +
                "室" +
                res.data.bed_no +
                "号床";
              this.house = true;
            } else {
              this.house = false;
            }
            this.data = res.data;
          } else {
            this.tipCtr(res.msg);
          }
          this._chooseCapacity();
        })
        .catch(err => {
          this.tipCtr(err);
        });
    },
    //类型
    _chooseCapacity() {
      let module = {
        sfzjh: Base64.encode(
          JSON.parse(sessionStorage.getItem("stuInfo")).sfzjh
        )
      };
      chooseCapacity(module).then(res => {
        if (res.status && res.data) {
          this.room = res.data.data;
        } else {
          this.tipCtr(res.msg);
        }
      });
    },
    //选择类型
    peroom(item) {
      this.active = item.capacity;
      this.Dorm = [];
      this.DormBed = [];
      this.show = false;
      this._chooseDorm(item.capacity);
    },
    //选择宿舍
    peDorm(item) {
      this.actives = item.ssmc;
      this.DormBed = [];
      this.dorm_id = item.id;
      this._chooseDormBed();
    },
    //提交
    peDormBed(item) {
      this.activeBed = item.id;
      this.bed_id = item.id;
    },
    //宿舍详情
    _chooseDorm(ty) {
      let module = {
        sfzjh: Base64.encode(
          JSON.parse(sessionStorage.getItem("stuInfo")).sfzjh
        ),
        capacity: ty
      };
      this.flag = true;
      chooseDorm(module)
        .then(res => {
          this.flag = false;
          this.tipCtr(res.msg);
          if (res.status && res.data) {
            this.Dorm = res.data;
          }
        })
        .catch(() => {
          this.tipCtr(res.msg);
        });
    },

    //宿舍详情
    _chooseDormBed() {
      this.flag = true;
      this.show = true;
      let module = {
        dorm_id: this.dorm_id,
        sfzjh: Base64.encode(
          JSON.parse(sessionStorage.getItem("stuInfo")).sfzjh
        )
      };
      chooseDormBed(module)
        .then(res => {
          this.flag = false;
          if (res.status) {
            this.DormBed = res.data;
          } else {
            this.tipCtr(res.msg);
          }
        })
        .catch(() => {
          this.tipCtr();
        });
    },

    //申请
    _dormBedApply() {
      if (this.dorm_id == "") {
        this.tipCtr("请选择宿舍");
        return;
      } else if (this.bed_id == "") {
        this.tipCtr("请选择床位");
        return;
      }

      return;
      let module = {
        sfzjh: Base64.encode(
          JSON.parse(sessionStorage.getItem("stuInfo")).sfzjh
        ),
        dorm_id: this.dorm_id,
        bed_id: this.bed_id
      };
      this.flag = true;
      dormBedApply(module).then(res => {
        this.flag = false;
        if (res.status) {
          this.tipCtr(res.msg);
        } else {
          this.tipCtr(res.msg);
        }
      });
    },

    changess() {
      this.isBuy = 1;
      this.exitshow = false;
    },
    changes() {
      this.isBuy = 2;
      this.exitshow = true;
      this.show = false;
      this.Dorm = [];
      this.DormBed = [];
      this._getRoomInfo();
      this._getRoomGoogs();
    },
    //获取宿舍用品信息
    _getRoomInfo() {
      getRoomInfo().then(res => {
        this.flag = false;
        if (res.status && res.data) {
          this.goods_list = res.data.goods_list;
          for (let i = 0; i < res.data.goods_list.length; i++) {
            this.buy_list.push(res.data.goods_list[i].id);
          }
        }
      });
    },
    //获取宿舍购买记录
    _getRoomGoogs() {
      this.flag = true;
      let module = {
        rid: JSON.parse(sessionStorage.getItem("stuInfo")).id,
        sfzjh: Base64.encode(
          JSON.parse(sessionStorage.getItem("stuInfo")).sfzjh
        )
      };
      getRoomGoogs(module).then(res => {
        this.flag = false;
        if (res.status) {
          this.goods_state = res.goods_state;
        } else {
          this.tipCtr(res.msg);
        }
      });
    },
    //购买
    _updateRoom() {
      if (this.goods_state != 0) {
        return;
      }
      let module = {
        rid: JSON.parse(sessionStorage.getItem("stuInfo")).id,
        idNum: Base64.encode(
          JSON.parse(sessionStorage.getItem("stuInfo")).sfzjh
        ),
        is_dorm: 1,
        is_buy: 1,
        buy_list: this.buy_list
      };
      updateRoom(module).then(res => {
        if (res.status) {
          this.tipCtr(res.msg);
        } else {
          this.tipCtr(res.msg);
        }
      });
    },
    //提示框方法
    tipCtr(text) {
      this.tip = text;
      this.tipShow = true;
      setTimeout(() => {
        this.tipShow = false;
      }, 1500);
    }
  }
};
</script>
<style scoped>
.oBox {
  width: 70%;
  padding: 30px 0;
  margin: 0 auto;
}
.form-horizontal i {
  color: red;
  font-size: 16px;
  vertical-align: text-top;
}

/***input 间距***/
form > div:last-child {
  margin-bottom: 0 !important;
}
.form-horizontal .form-group {
  margin: 0 0 20px;
}
/***input lable文字***/
.form-horizontal .control-label {
  padding-top: 8px;
  color: #333;
  font-size: 14px;
  text-align: left;
}
/***input***/
.form-control {
  height: 40px;
}
.radio-lable {
  padding-top: 9px;
  margin-right: 40px;
  cursor: pointer;
}

input[type="radio"] {
  /*radiobox   原始 样式修改   */
  width: 20px;
  height: 20px;
  margin: -2px 5px 0 0 !important;
  vertical-align: middle;
  cursor: pointer;
  background-color: #fff;
  -webkit-appearance: none;
  border: 1px solid #c9c9c9;
  outline: none;
  border-radius: 100%;
}
input[type="radio"]:checked {
  /*checkbox   选中 样式修改   */
  background: #ff9000;
  border: none;
}
.btn-box {
  text-align: center;
}
.btn-box button {
  margin-top: 50px;
  min-width: 40%;
}
.isbuyshow ul {
  padding: 5px 10px;
  border: 2px solid #ccc;
  border-radius: 1px;
}
.isbuyshow ul .lid {
  padding: 8px;
  margin: 5px 0;
  font-size: 16px;
  border-radius: 4px;
}
.isbuyshow ul .lid .num {
  color: chocolate;
  float: right;
  display: inline-block;
  width: 20%;
  font-weight: 600;
}
.isbuyshow ul .lid:nth-child(2n) {
  background: aliceblue;
}
.isbuyshow ul .lid:nth-child(2n-1) {
  background: skyblue;
}
/* 宿舍 */

.peroom span {
  width: 20%;
  text-align: center;
  align-items: center;
  margin: 5px 10px;
  padding: 8px;
  font-weight: bold;
  border: 1px solid #ccc;
  border-radius: 4px;
  display: inline-block;
  cursor: pointer;
}
.active {
  background: #fd7522;
  border: 1px solid #fd7522;
  color: #fff;
}
.actives {
  border: 1px solid #1f86ec !important;
  color: #1f86ec;
}
.activeBed {
  border: 1px solid #1f86ec !important;
  color: #1f86ec;
  background: #d7ebff;
}
.dormchoose span {
  display: inline-block;
  margin: 5px 2px;
  padding: 5px;
  border: 1px solid #ccc;
  border-radius: 4px;
  cursor: pointer;
}
.roombed {
  color: #333;
}
.DormBedchoose span {
  display: inline-block;
  margin: 5px 2px;
  padding: 5px 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  cursor: pointer;
}
.exit {
  margin: 5px 2px;
  padding: 5px 20px;
  font-weight: bold;
  border: 1px solid orange;
  border-radius: 4px;
  color: orange;
  cursor: pointer;
}

.sushe {
  color: red;
  height: 3rem;
  line-height: 3rem;
}
</style>


// WEBPACK FOOTER //
// src/components/roomInfo.vue